import { TravailDTO } from '@logaia_users/logaia-dto';

export class DossierUtil {
  static isSaisieTravailAutorise(
    travail: TravailDTO | undefined,
    login: string,
  ): boolean {
    if (!travail) {
      return true;
    }

    const currentLoginLower = login.toLowerCase();
    const loginCreationLower = travail.loginCreation.toLowerCase();

    // Vérification du créateur du travail
    if (loginCreationLower === currentLoginLower) {
      return true;
    }

    // Vérification du compte administrateur "ASSLG"
    if (currentLoginLower === 'asslg') {
      return true;
    }

    // Vérification de la liste des logins autorisés
    const isUserAuthorized = travail.loginAutorises.some(
      (t) => t.login.toLowerCase() === currentLoginLower,
    );

    if (!isUserAuthorized) {
      return false;
    }

    return true;
  }
}
